import type { UseControllerProps } from 'react-hook-form';
import { useController, useFormContext } from 'react-hook-form';

import { Checkbox } from 'components/UI/Tailwind/Checkbox';

export interface FormCheckbox
  extends Omit<Checkbox, 'name'>,
    Pick<UseControllerProps, 'name'> {}

export function FormCheckbox({ name, ...props }: FormCheckbox) {
  const { control } = useFormContext();

  const { field } = useController({
    control,
    name,
  });

  return (
    <Checkbox
      {...props}
      {...field}
      checked={field.value}
      onChange={(...args) => {
        field.onChange(...args);
        props.onChange?.(...args);
      }}
    />
  );
}
